import { getLocalStorage, LS_AUTHTYPE } from '../lib/storage';

export const ADMIN = 8;
export const EDITOR = 4;
export const VIEWER = 2;

export const isAdmin = () => {
  const userType = getLocalStorage(LS_AUTHTYPE);
  return !!userType && 8 === +userType;
};

export const isEditor = () => {
  const userType = getLocalStorage(LS_AUTHTYPE);
  return !!userType && 4 === +userType;
};

export const isViewer = () => {
  const userType = getLocalStorage(LS_AUTHTYPE);
  return !!userType && 2 === +userType;
};

export const checkAuth = (check) => {
  const userType = +getLocalStorage(LS_AUTHTYPE);
  if (!userType) return false;

  // Sfrutta la gerarchia numerica: se il tipo utente è >= al check richiesto, è autorizzato
  // NB: Questo assume che i valori siano sempre ADMIN(8) > EDITOR(4) > VIEWER(2)
  return userType >= check;
};
